import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../environments/environment";
import { ServiceCategory } from "../../../models/service-category";
import {
  ServiceCategoryControllerService,
} from "../../../services/service-categories-controller/service-category-controller.service";
import { SystemProperties } from "../../../models/system-properties";
import {
  SystemPropertiesControllerService,
} from "../../../services/system-settings/system-properties-controller.service";
import { ClassicEditor } from "../../../../assets/libs/ckeditor5";
import { Store } from "../../../services/store.service";
import { TranslateService } from "@ngx-translate/core";
import { TranslatedBaseError } from "../TranslatedBaseError";

@Component({
  selector: "settings",
  templateUrl: "./settings.component.html",
})
export class SettingsComponent extends TranslatedBaseError implements OnInit {

  public logoUrl: string = null;
  public logoFileId: string = null;
  public faviconUrl: string = null;
  public faviconFileId: string = null;
  private restheartUrl: string = environment.RESTHEART_URL;
  private baseUrl: string = environment.BASE_URL;
  public allCategories: ServiceCategory[];
  public newCategory: string;
  public systemProperties = new SystemProperties();
  public footer = {};
  public footer_content = "";
  public selectedTab = "general";
  public tabsType: string = "tabs";
  public publishBPAOption: any;


  public Editor = ClassicEditor;
  public config = {
    toolbar: {
      items: [
        "heading",
        "|",
        "fontFamily",
        "fontSize",
        "fontColor",
        "underline",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "alignment",
        "outdent",
        "indent",
        "|",
        "imageUpload",
        "blockQuote",
        "insertTable",
        "mediaEmbed",
        "undo",
        "redo",
        "|",
        "horizontalLine",
        "|",
        "removeFormat",
      ],
    },
    language: this.store.state.common.lang,
    image: {
      toolbar: [
        "imageTextAlternative",
        "imageStyle:full",
        "imageStyle:side",
        "linkImage",
      ],
    },
    table: {
      contentToolbar: [
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "tableCellProperties",
        "tableProperties",
      ],
    },
  };

  constructor(
    public toastr: ToastrService,
    private serviceCategoryControllerService: ServiceCategoryControllerService,
    private systemPropertiesControllerService: SystemPropertiesControllerService,
    private http: HttpClient,
    public store: Store,
    public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit(): void {
    this.logoUrl = this.restheartUrl + "eregsystem/eregsystem.files/logo/binary";
    this.faviconUrl = this.restheartUrl + "eregsystem/eregsystem.files/favicon/binary";
    this.loadServiceCategories();
    this.loadSystemProperties();
    this.translateService.onLangChange.subscribe(() => {
      this.footer_content = this.footer[this.getCurrentLang()] || "";
    });
  }

  public initTabs(): void {
    const container = document.getElementById("tabsContainer");
    const tabs = document.getElementById("tabsList");
    const tabsResp = document.getElementById("tabsResp");
    container.classList.remove("d-none");
    tabs.classList.add("loading");
    tabs.classList.remove("d-none");
    tabsResp.classList.add("loading");
    tabs.classList.remove("d-none");
    tabsResp.classList.remove("d-none");
    if (container && tabs) {
      tabs.classList.remove("loading");
      tabsResp.classList.remove("loading");
      if (Number(container.getBoundingClientRect().width) <= (tabs.getBoundingClientRect().width)) {
        tabsResp.classList.remove("d-none");
        tabs.classList.add("d-none");
        this.tabsType = "tabs";
      } else {
        this.tabsType = "dropdown";
        tabs.classList.remove("d-none");
        tabsResp.classList.add("d-none");
      }
    }
  }

  public onResize(event) {
    this.initTabs();
  }

  public ngAfterViewInit(): void {
    this.initTabs();
  }

  public getCurrentLang() {
    return this.translateService?.store?.currentLang || this.translateService?.store?.defaultLang;
  }

  public deleteLogo() {
    return this.http.delete(this.baseUrl + "system/logo").subscribe((data) => {
      this.logoUrl = null;
    });
  }

  public deleteFavicon() {
    return this.http.delete(this.baseUrl + "system/favicon").subscribe((data) => {
      this.faviconUrl = null;
    });
  }

  public logoFileIdChanged(logoFileId: string) {
    if (logoFileId) {
      this.logoFileId = logoFileId;
      this.updateLogoUrl();
    }
  }

  public faviconFileIdChanged(faviconFileId: string) {
    if (faviconFileId) {
      this.faviconFileId = faviconFileId;
      this.updateFaviconUrl();
    }
  }

  public updateLogoUrl() {
    this.logoUrl = this.restheartUrl + "eregsystem/eregsystem.files/logo/binary?change=" + Math.random();
  }

  public updateFaviconUrl() {
    this.faviconUrl = this.restheartUrl + "eregsystem/eregsystem.files/favicon/binary?change=" + Math.random();
  }

  public loadSystemProperties() {
    this.systemPropertiesControllerService.getServiceProperties().subscribe(
      (systemProperties) => {
        console.log(systemProperties);
        if (systemProperties) {
          this.systemProperties = systemProperties;
          if (!this.systemProperties.bpaProperties) {
            this.systemProperties.bpaProperties = {};
          }
          if (!this.systemProperties.bpaProperties.defaultGroupDefault) {
            this.systemProperties.bpaProperties.defaultGroupDefault = false;
          }
          if (this.systemProperties.displaySystemProperties.find((p) => p.name === "request_release_notes_at_publishing")) {
            this.publishBPAOption = this.systemProperties.displaySystemProperties.find((p) => p.name === "request_release_notes_at_publishing");
          } else {
            this.publishBPAOption = {
              name: "request_release_notes_at_publishing",
              enabled: false,
            };
            this.systemProperties.displaySystemProperties.push(this.publishBPAOption);
          }
          if (this.systemProperties.footer) {
            this.footer = JSON.parse(this.systemProperties.footer);
            this.footer_content = this.footer[this.getCurrentLang()] || "";
          }
        }
      },
    );
  }

  public updateServiceProperties() {
    this.systemPropertiesControllerService.updateServiceProperties(this.systemProperties).subscribe(
      (data) => {
        this.responseSuccessful("System properties updated");
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public updateFooter() {
    this.footer[this.getCurrentLang()] = this.footer_content;
    this.systemProperties.footer = JSON.stringify(this.footer);
    this.systemPropertiesControllerService.updateServiceProperties(this.systemProperties).subscribe(
      (data) => {
        this.responseSuccessful("System properties updated");
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public loadServiceCategories() {
    this.serviceCategoryControllerService.getAllServiceCategories().subscribe(
      (allCategories) => {
        if (allCategories && allCategories.length > 0) {
          this.allCategories = allCategories;
        }
      },
    );
  }

  public removeCatecory(cat: ServiceCategory) {
    this.serviceCategoryControllerService.deleteCategory(cat.id).subscribe(
      (data) => {
        this.loadServiceCategories();
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public submitEditOnFocus() {
    // Check if value has changed
    if (this.newCategory !== "") {
      this.addNewCategory(this.newCategory);
    }
  }

  public addNewCategory(newCategory: string) {
    const serviceCategory: ServiceCategory = new ServiceCategory();
    serviceCategory.category = newCategory;
    this.serviceCategoryControllerService.createCategory(serviceCategory).subscribe(
      (data) => {
        this.newCategory = "";
        this.responseSuccessful("Category created!");
        this.loadServiceCategories();
      },
      (error) => this.showErrorMessage(error),
    );
  }

}
